// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bLoading {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  height: 100%;
  justify-content: center;
  text-align: center;
}

.eClearItemButton {
  display: inline-block;
}

.inline-calendar {
  font-family: inherit;
  color: inherit;
  background-color: transparent;
  border: 1px solid #ccc;
  padding: 0.25rem;
}

.bGenericView {
  display: flex;
  flex-direction: column;
  height: 100vh;
  min-height: 0;
  overflow: hidden;
  background: var(--surface-page, #f8fafc);
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif);
}

.bGenericViewShell {
  flex: 1 1 auto;
  min-height: 0;
  padding: 0 !important;
  overflow: hidden;
  background: var(--surface-page, #f8fafc);
}

.bGenericViewRow {
  height: 100%;
  min-height: 0;
  margin-left: 0 !important;
  margin-right: 0 !important;
  flex-wrap: nowrap;
}

.bGenericSidebarColumn {
  flex: 0 0 248px;
  width: 248px;
  max-width: 248px;
  height: 100%;
  min-height: 0;
  padding: 0 !important;
  overflow: hidden;
  background: #123651;
  border-right: 0;
}

.bGenericContentColumn {
  flex: 1 1 auto;
  max-width: none;
  min-width: 0;
  height: 100%;
  min-height: 0;
  padding: 20px 24px 32px !important;
  overflow-x: hidden;
  overflow-y: auto;
  background: var(--surface-page, #f8fafc);
  scrollbar-width: thin;
  scrollbar-color: var(--slate-300, #cbd5e1) transparent;
}

.bGenericContentColumn::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.bGenericContentColumn::-webkit-scrollbar-thumb {
  background: var(--slate-300, #cbd5e1);
  border: 3px solid transparent;
  border-radius: 999px;
  background-clip: content-box;
}

.bGenericContentColumn::-webkit-scrollbar-thumb:hover {
  background: var(--slate-400, #94a3b8);
  background-clip: content-box;
}

.bGenericContentColumn--full {
  width: 100%;
}

/* Union screens historically carry Bootstrap/container max-widths in many page roots.
   Keep the whole admin workspace anchored to the sidebar when the viewport grows or is zoomed out. */
.bGenericView--union .bGenericContentColumn > * {
  width: 100% !important;
  max-width: none !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.bGenericView--union .bGenericContentColumn .container,
.bGenericView--union .bGenericContentColumn .container-fluid {
  width: 100% !important;
  max-width: none !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

@media (max-width: 1217px) {
  .bGenericViewRow {
    display: block;
  }

  .bGenericSidebarColumn--mobile {
    width: 0;
    max-width: none;
    border-right: 0;
  }

  .bGenericContentColumn {
    padding: 16px 12px 28px !important;
  }
}

/* SLT owns its page spacing; avoid combining it with the generic shell padding. */
.bGenericView--slt .bGenericContentColumn { padding: 0 !important; }
@media (min-width: 1218px) {
  .bGenericView--slt .bGenericSidebarColumn { flex-basis: 232px; width: 232px; max-width: 232px; }
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/GenericView.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,6BAA6B;EAC7B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,wCAAwC;EACxC,gCAAgC;EAChC,8FAA8F;AAChG;;AAEA;EACE,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;qGACqG;AACrG;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,QAAQ;IACR,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kCAAkC;EACpC;AACF;;AAEA,kFAAkF;AAClF,4CAA4C,qBAAqB,EAAE;AACnE;EACE,4CAA4C,iBAAiB,EAAE,YAAY,EAAE,gBAAgB,EAAE;AACjG","sourcesContent":[".bLoading {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n  height: 100%;\n  justify-content: center;\n  text-align: center;\n}\n\n.eClearItemButton {\n  display: inline-block;\n}\n\n.inline-calendar {\n  font-family: inherit;\n  color: inherit;\n  background-color: transparent;\n  border: 1px solid #ccc;\n  padding: 0.25rem;\n}\n\n.bGenericView {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  min-height: 0;\n  overflow: hidden;\n  background: var(--surface-page, #f8fafc);\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif);\n}\n\n.bGenericViewShell {\n  flex: 1 1 auto;\n  min-height: 0;\n  padding: 0 !important;\n  overflow: hidden;\n  background: var(--surface-page, #f8fafc);\n}\n\n.bGenericViewRow {\n  height: 100%;\n  min-height: 0;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n  flex-wrap: nowrap;\n}\n\n.bGenericSidebarColumn {\n  flex: 0 0 248px;\n  width: 248px;\n  max-width: 248px;\n  height: 100%;\n  min-height: 0;\n  padding: 0 !important;\n  overflow: hidden;\n  background: #123651;\n  border-right: 0;\n}\n\n.bGenericContentColumn {\n  flex: 1 1 auto;\n  max-width: none;\n  min-width: 0;\n  height: 100%;\n  min-height: 0;\n  padding: 20px 24px 32px !important;\n  overflow-x: hidden;\n  overflow-y: auto;\n  background: var(--surface-page, #f8fafc);\n  scrollbar-width: thin;\n  scrollbar-color: var(--slate-300, #cbd5e1) transparent;\n}\n\n.bGenericContentColumn::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n.bGenericContentColumn::-webkit-scrollbar-thumb {\n  background: var(--slate-300, #cbd5e1);\n  border: 3px solid transparent;\n  border-radius: 999px;\n  background-clip: content-box;\n}\n\n.bGenericContentColumn::-webkit-scrollbar-thumb:hover {\n  background: var(--slate-400, #94a3b8);\n  background-clip: content-box;\n}\n\n.bGenericContentColumn--full {\n  width: 100%;\n}\n\n/* Union screens historically carry Bootstrap/container max-widths in many page roots.\n   Keep the whole admin workspace anchored to the sidebar when the viewport grows or is zoomed out. */\n.bGenericView--union .bGenericContentColumn > * {\n  width: 100% !important;\n  max-width: none !important;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n\n.bGenericView--union .bGenericContentColumn .container,\n.bGenericView--union .bGenericContentColumn .container-fluid {\n  width: 100% !important;\n  max-width: none !important;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n\n@media (max-width: 1217px) {\n  .bGenericViewRow {\n    display: block;\n  }\n\n  .bGenericSidebarColumn--mobile {\n    width: 0;\n    max-width: none;\n    border-right: 0;\n  }\n\n  .bGenericContentColumn {\n    padding: 16px 12px 28px !important;\n  }\n}\n\n/* SLT owns its page spacing; avoid combining it with the generic shell padding. */\n.bGenericView--slt .bGenericContentColumn { padding: 0 !important; }\n@media (min-width: 1218px) {\n  .bGenericView--slt .bGenericSidebarColumn { flex-basis: 232px; width: 232px; max-width: 232px; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
